import {
  FormatterMiddlewareFormatParams,
  TolgeeInstance,
  TolgeePlugin,
  TranslationValue,
  TranslationsFlat,
} from '@tolgee/react';
import { isNil } from 'lodash-es';

/**
 * 单复数格式化
 * 规则: 以 _other 的 key，内容存在 count 参数时进行转换
 * 例如:
 * "store": "{{count}} store",
 * "store_other": "{{count}} stores"
 */
const createPluralFormat = (tolgee: TolgeeInstance) => {
  const getOtherTranslation = (translation: string, record: TranslationsFlat) => {
    const result: Array<{
      key: string;
      translation: string;
      translationOther: TranslationValue;
    }> = [];
    const keys = Object.keys(record);
    keys.forEach((key) => {
      const value = record[key];
      if (translation === value) {
        result.push({
          key,
          translation,
          translationOther: record[`${key}_other`],
        });
      }
    });
    if (result.length > 1) {
      console.warn(
        `[PluralFormat]translation %s 存在多个 key 的冲突，请解决 key diff 冲突 %s`,
        translation,
        result.map(({ key }) => key).join(', '),
      );
      return undefined;
    }

    return result[0];
  };

  const format = (props: FormatterMiddlewareFormatParams) => {
    const { language, translation, params } = props;

    // 参数中存在 count 关键字
    if (!isNil(params?.count)) {
      const record = tolgee.getRecord({
        language,
      });

      if (record) {
        const other = getOtherTranslation(translation, record.data);
        if (other && other.translationOther && params?.count > 1) {
          return other.translationOther;
        }
      }
    }

    return translation;
  };

  return Object.freeze({ format });
};

export const PluralFormat = (): TolgeePlugin => (tolgee, tools) => {
  tools.addFormatter(createPluralFormat(tolgee));

  return tolgee;
};
